import type { ActionToast } from '@tunasong/ui-lib'
import { createContext, useContext } from 'react'

/**
 * The chat's one toast, for content it hosts (chat makeover M3, #2718). A group's "Comment resolved." with Undo must
 * outlive the group, which drops out once its last comment is resolved, so the chat shows it.
 */
export const ChatToastContext = createContext<(toast: ActionToast) => void>(() => undefined)

export const useChatToast = () => useContext(ChatToastContext)
